import { connect } from 'react-redux';
import { getPublicSession } from '../../publicSession/selectors';
import { attemptSocialLogin } from '../redux/actions';
const mapStateToProps = (state)=>{
    var _session_appIds;
    const session = getPublicSession(state);
    return {
        clientId: ((_session_appIds = session.appIds) === null || _session_appIds === void 0 ? void 0 : _session_appIds.appleAppId) || '',
        sessionId: session.sessionId
    };
};
const mapDispatchToProps = {
    attemptSocialLogin
};
export default connect(mapStateToProps, mapDispatchToProps);
